<template>
  <div class="sk-connect-page">
    <div class="sk-topbar">
      <a href="https://sentrykit.com" class="sk-logo">
        <img src="https://sentrykit.com/wp-content/uploads/2026/04/Sk-2.0-logo-white.png" alt="SentryKit" style="height:48px;width:auto;display:block;">
      </a>
    </div>
    <div class="sk-main-wide">
      <div class="sk-two-col-card sk-invite-card">
        <div v-if="loading" class="sk-form-panel">
          <div class="sk-spinner" style="margin: 0 auto 16px;"></div>
          <p>Loading…</p>
        </div>
        <div v-else-if="status === 'used'" class="sk-form-panel">
          <div class="sk-amz-connected"><span class="sk-micro-tick">✓</span> Done. {{ inviterName }} can see your listings in SentryKit now.</div>
          <p class="sk-form-sub">You can close this page. No SentryKit account was created for you.</p>
        </div>
        <div v-else-if="status === 'expired' || status === 'missing'" class="sk-form-panel">
          <h1>This link can't be used</h1>
          <p class="sk-form-sub">{{ status === 'expired' ? 'This link has expired. Ask them to copy a new one from SentryKit.' : 'This link is not valid.' }}</p>
        </div>
        <div v-else class="sk-form-panel">
          <p class="sk-invite-lead">{{ inviterName }} asked you to connect {{ accountLabel }}'s Amazon store to SentryKit.</p>
          <connect-region-form :working="working" :error="error" @connect="startConnect" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './styles/signup-flow.css'
import ConnectRegionForm from './components/ConnectRegionForm.vue'
import { startAmazonAuthorization } from './utils/amazonAuthorizationStart'

export default {
  components: { ConnectRegionForm },
  data: function () {
    return {
      loading: true,
      status: '',
      inviterName: '',
      accountLabel: '',
      working: false,
      error: ''
    }
  },
  computed: {
    token: function () {
      return this.$route.params.token
    }
  },
  methods: {
    loadInvite: function () {
      var self = this
      self.loading = true
      self.$http.get('/api/v1/connect-invites/' + encodeURIComponent(self.token)).then(
        function (response) {
          var body = response.body || {}
          self.status = body.status || 'missing'
          self.inviterName = body.inviterName || 'They'
          self.accountLabel = body.accountLabel || 'their'
          self.loading = false
        },
        function (response) {
          self.loading = false
          self.status = response.status === 410 ? 'expired' : 'missing'
        }
      )
    },
    startConnect: function (params) {
      var self = this
      if (self.working) return
      self.working = true
      self.error = ''
      startAmazonAuthorization(self.$http, {
        url: '/api/v1/connect-invites/' + encodeURIComponent(self.token) + '/authorization/redirect',
        params: params,
        method: 'invite',
        gtm: { source: 'invite', region: params.region, marketplaces: params.marketplaceCodes }
      }).then(function () {}, function (message) {
        self.working = false
        self.error = message || 'Failed to start authorization'
      })
    }
  },
  created: function () {
    this.loadInvite()
  },
  mounted: function () {
    var el = document.getElementById('preloadr')
    if (el) {
      el.style.display = 'none'
    }
    var self = this
    this.onPageShow = function (e) {
      if (e.persisted) self.working = false
    }
    window.addEventListener('pageshow', this.onPageShow)
  },
  beforeDestroy: function () {
    if (this.onPageShow) window.removeEventListener('pageshow', this.onPageShow)
  }
}
</script>

<style scoped>
.sk-connect-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--sk-bg, #f0f4f9);
  overflow-x: hidden;
}
.sk-invite-card {
  max-width: 560px;
  display: block;
}
.sk-invite-lead {
  margin: 0 0 8px;
  font-size: 15px;
  line-height: 1.45;
  color: #334155;
}
</style>



// WEBPACK FOOTER //
// ConnectInvitePage.vue?58c6facd